import PropTypes from 'prop-types'

import AttackTypeIcon from 'components/common/AttackTypeIcon'
import GlyphIcon from 'components/common/GlyphIcon'
import { getNextScheduled } from 'components/navigation/Notifications/utils'
import { getFormattedAttackType } from 'utils/metadata'

import AttackRow, {
  AttackDescription,
  TargetsColumn,
  DetailsChevron
} from './common/AttackRow'
import { IlfiTargets } from './common/Targets'

export default function ScheduledAttackRow({ schedule }) {
  const { trigger } = schedule
  return (
    <AttackRow
      data-scheduled-attack-row
      css={{
        gridTemplateColumns: 'minmax(172px, 1fr) minmax(0, 1fr) 24px'
      }}
      to="/schedules/attacks"
    >
      <AttackDescription
        description={getNextScheduled(trigger)}
        icon={
          <GlyphIcon>
            <AttackTypeIcon icon={schedule.command.type} />
          </GlyphIcon>
        }
        name={getFormattedAttackType(schedule.command.type)}
      />
      <TargetsColumn>
        <IlfiTargets
          targets={
            schedule.target.type === 'Random'
              ? ['Random']
              : schedule.target.exact ||
                (schedule.target.containers || schedule.target.hosts).ids
          }
        />
      </TargetsColumn>
      <DetailsChevron />
    </AttackRow>
  )
}

ScheduledAttackRow.propTypes = {
  schedule: PropTypes.object
}
